import React from 'react';
import {observer} from "mobx-react";
import styled from "styled-components";
import {useServices} from '../../../hooks/use-services.hook';
import {PrimaryButtonInverted} from "../../../basic-components/buttons/primary-button-inverted";
import {IonIcon} from "@ionic/react";
import {logOutOutline} from "ionicons/icons";
import {YesNoDialogPrimaryButton, YesNoDialogResult} from "../../../services/dialog-factory/yes-no-dialog.enums";


const SideMenuFooterBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: ${props => props.theme.spacing.spacing16} 
             ${props => props.theme.spacing.spacing16}
             calc(env(safe-area-inset-bottom) + ${props => props.theme.spacing.spacing16})
             ${props => props.theme.spacing.spacing16};
`

const LogoutButtonBox = styled(PrimaryButtonInverted)`
    justify-content: space-between;
`

const LogoutButtonIconBox = styled.div`
    font-size: 20px;
`

export const AgencySideMenuFooter: React.FC = observer(() => {
    const services = useServices();
    const logout = async () => {
        const dialogResult = await services.dialogFactory.showYesNoDialog({
            title: services.language.translate('Logout confirmation'),
            message: services.language.translate('Are you sure you want to logout?'),
            primaryButton: YesNoDialogPrimaryButton.PrimaryButtonNo
        });

        if(dialogResult === YesNoDialogResult.Yes) {
            await services.user.logout();
            await services.sideMenu.agencyMainSideMenuController.close();
        }

    }
    return (
        <SideMenuFooterBox>
            <LogoutButtonBox onClick={logout}>
                <span>Logout</span>
                <LogoutButtonIconBox>
                    <IonIcon icon={logOutOutline}/>
                </LogoutButtonIconBox>

            </LogoutButtonBox>
        </SideMenuFooterBox>
    )
})